module.exports = __webpack_public_path__ + "img/certificados.0d994cd9.png";